module.exports = __webpack_public_path__ + "static/media/sushiswap-logo.39c3f991.png";